// extracted by mini-css-extract-plugin
export default {"root":"InfoBoxWithLink_root__YnOOP","mainLabel":"InfoBoxWithLink_mainLabel__1-j6d","box":"InfoBoxWithLink_box__Qz93J"};